import { render, staticRenderFns } from "./comTable.vue?vue&type=template&id=65ad641e&scoped=true&"
import script from "./comTable.vue?vue&type=script&lang=js&"
export * from "./comTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ad641e",
  null
  
)

export default component.exports